module.exports = __webpack_public_path__ + "static/media/nexthink-whiteout.77f9759a.png";